import { DateFilter } from '../../types/date-filter';
import { generateDate } from '../../utils/dummy-data';
import { Customer } from '../model/customer';
import { CurrencyCode } from '../model/enum/currency-code';

export const CUSTOMERS: Customer[] = [
  {
    id: 1,
    createdAt: generateDate(DateFilter.TODAY),
    updatedAt: new Date('2022-05-10'),
    firstName: 'John',
    lastName: 'Doe',
    mobile: {
      countryCode: '+63',
      number: '9123456789',
    },
    telephone: {
      countryCode: '+63',
      number: '212345678',
    },
    email: 'john@example.com',
    birthday: new Date('1985-08-15'),
    note: 'Regular customer',
    company: 'ABC Company',
    unitFloorRoomBuildingNo: 'Unit 1203, 12/F',
    buildingNameTower: 'Sunrise Residences Tower 2',
    lotBlockPhaseHouseNo: 'Lot 8 Block 3',
    street: 'J.P. Rizal Street',
    subdivisionVillageZone: 'Green Meadows Subdivision',
    barangay: 'Barangay Pinagkaisahan',
    district: '2nd District',
    city: 'Mandaluyong City',
    province: 'Metro Manila',
    zipCode: '1550',
    taxId: '1234',
    childName: null,
    childBirthDate: null,
  },
  {
    id: 2,
    createdAt: generateDate(DateFilter.TODAY),
    updatedAt: new Date('2022-05-11'),
    firstName: 'Jane',
    lastName: 'Doe',
    mobile: {
      countryCode: '+63',
      number: '9987654321',
    },
    telephone: {
      countryCode: '+63',
      number: '212345678',
    },
    email: 'jane@example.com',
    birthday: new Date('1990-03-20'),
    note: 'VIP customer',
    company: 'XYZ Corporation',
    unitFloorRoomBuildingNo: 'Unit 1204, 12/F',
    buildingNameTower: 'Sunrise Residences Tower 2',
    lotBlockPhaseHouseNo: 'Lot 8 Block 3',
    street: 'J.P. Rizal Street',
    subdivisionVillageZone: 'Green Meadows Subdivision',
    barangay: 'Barangay Pinagkaisahan',
    district: '2nd District',
    city: 'Mandaluyong City',
    province: 'Metro Manila',
    zipCode: '1550',
    taxId: '1234',
    childName: null,
    childBirthDate: null,
  },
  {
    id: 3,
    createdAt: generateDate(DateFilter.LAST_7_DAYS),
    updatedAt: new Date('2022-05-12'),
    firstName: 'Michael',
    lastName: 'Smith',
    mobile: {
      countryCode: '+63',
      number: '9876543210',
    },
    telephone: {
      countryCode: '+63',
      number: '212345678',
    },
    email: 'michael@example.com',
    birthday: new Date('1982-11-10'),
    note: 'Preferred customer',
    company: 'DEF Enterprises',
    unitFloorRoomBuildingNo: 'Unit 1205, 12/F',
    buildingNameTower: 'Sunrise Residences Tower 2',
    lotBlockPhaseHouseNo: 'Lot 8 Block 3',
    street: 'J.P. Rizal Street',
    subdivisionVillageZone: 'Green Meadows Subdivision',
    barangay: 'Barangay Pinagkaisahan',
    district: '2nd District',
    city: 'Mandaluyong City',
    province: 'Metro Manila',
    zipCode: '1550',
    taxId: '1234',
    childName: null,
    childBirthDate: null,
  },
  {
    id: 4,
    createdAt: generateDate(DateFilter.LAST_7_DAYS),
    updatedAt: new Date('2022-05-13'),
    firstName: 'Michael',
    lastName: 'Johnson',
    mobile: {
      countryCode: '+63',
      number: '9765432109',
    },
    telephone: {
      countryCode: '+63',
      number: '212345678',
    },
    email: 'emily@example.com',
    birthday: new Date('1978-06-25'),
    note: 'New customer',
    company: 'GHI Industries',
    unitFloorRoomBuildingNo: 'Unit 801, 8/F',
    buildingNameTower: 'Sunrise Residences Tower 1',
    lotBlockPhaseHouseNo: 'Lot 8 Block 3',
    street: 'J.P. Rizal Street',
    subdivisionVillageZone: 'Green Meadows Subdivision',
    barangay: 'Barangay Pinagkaisahan',
    district: '2nd District',
    city: 'Mandaluyong City',
    province: 'Metro Manila',
    zipCode: '1550',
    taxId: '1234',
    childName: null,
    childBirthDate: null,
  },
  {
    id: 5,
    createdAt: generateDate(DateFilter.LAST_4_WEEKS),
    updatedAt: new Date('2022-05-14'),
    firstName: 'David',
    lastName: 'Williams',
    mobile: {
      countryCode: '+63',
      number: '9654321098',
    },
    telephone: {
      countryCode: '+63',
      number: '212345678',
    },
    email: 'david@example.com',
    birthday: new Date('1995-02-18'),
    note: 'Frequent customer',
    company: 'JKL Corporation',
    unitFloorRoomBuildingNo: 'Unit 608, 6/F',
    buildingNameTower: 'Sunrise Residences Tower 1',
    lotBlockPhaseHouseNo: 'Lot 8 Block 3',
    street: 'J.P. Rizal Street',
    subdivisionVillageZone: 'Green Meadows Subdivision',
    barangay: 'Barangay Pinagkaisahan',
    district: '2nd District',
    city: 'Mandaluyong City',
    province: 'Metro Manila',
    zipCode: '1550',
    taxId: '1234',
    childName: null,
    childBirthDate: null,
  },
  {
    id: 6,
    createdAt: generateDate(DateFilter.LAST_4_WEEKS),
    updatedAt: new Date('2022-05-15'),
    firstName: 'Sarah',
    lastName: 'Brown',
    mobile: {
      countryCode: '+63',
      number: '9543210987',
    },
    telephone: {
      countryCode: '+63',
      number: '212345678',
    },
    email: 'sarah@example.com',
    birthday: new Date('1989-09-30'),
    note: 'Loyal customer',
    company: 'MNO Corporation',
    unitFloorRoomBuildingNo: 'Unit 711, 7/F',
    buildingNameTower: 'Sunrise Residences Tower 2',
    lotBlockPhaseHouseNo: 'Lot 8 Block 3',
    street: 'J.P. Rizal Street',
    subdivisionVillageZone: 'Green Meadows Subdivision',
    barangay: 'Barangay Pinagkaisahan',
    district: '2nd District',
    city: 'Mandaluyong City',
    province: 'Metro Manila',
    zipCode: '1550',
    taxId: '1234',
    childName: null,
    childBirthDate: null,
  },
  {
    id: 7,
    createdAt: generateDate(DateFilter.LAST_12_MONTHS),
    updatedAt: new Date('2022-05-16'),
    firstName: 'Christopher',
    lastName: 'Lee',
    mobile: {
      countryCode: '+63',
      number: '9432109876',
    },
    telephone: {
      countryCode: '+63',
      number: '212345678',
    },
    email: 'christopher@example.com',
    birthday: new Date('1980-04-12'),
    note: 'Regular customer',
    company: 'PQR Enterprises',
    unitFloorRoomBuildingNo: 'Unit 1001, 10/F',
    buildingNameTower: 'Sunrise Residences Tower 1',
    lotBlockPhaseHouseNo: 'Lot 8 Block 3',
    street: 'J.P. Rizal Street',
    subdivisionVillageZone: 'Green Meadows Subdivision',
    barangay: 'Barangay Pinagkaisahan',
    district: '2nd District',
    city: 'Mandaluyong City',
    province: 'Metro Manila',
    zipCode: '1550',
    taxId: '1234',
    childName: null,
    childBirthDate: null,
  },
  {
    id: 8,
    createdAt: generateDate(DateFilter.LAST_12_MONTHS),
    updatedAt: new Date('2022-05-17'),
    firstName: 'Jessica',
    lastName: 'Martinez',
    mobile: {
      countryCode: '+63',
      number: '9321098765',
    },
    telephone: {
      countryCode: '+63',
      number: '212345678',
    },
    email: 'jessica@example.com',
    birthday: new Date('1976-12-03'),
    note: 'Preferred customer',
    company: 'STU Industries',
    unitFloorRoomBuildingNo: 'Unit 305, 3/F',
    buildingNameTower: 'Sunrise Residences Tower 1',
    lotBlockPhaseHouseNo: 'Lot 8 Block 3',
    street: 'J.P. Rizal Street',
    subdivisionVillageZone: 'Green Meadows Subdivision',
    barangay: "Barangay Pinagkaisahan",
    district: '2nd District',
    city: 'Mandaluyong City',
    province: 'Metro Manila',
    zipCode: '1550',
    taxId: '1234',
    childName: null,
    childBirthDate: null,
  },
  {
    id: 9,
    createdAt: generateDate(DateFilter.MAX),
    updatedAt: new Date('2022-05-18'),
    firstName: 'Daniel',
    lastName: 'Garcia',
    mobile: {
      countryCode: '+63',
      number: '9210987654',
    },
    telephone: {
      countryCode: '+63',
      number: '212345678',
    },
    email: 'daniel@example.com',
    birthday: new Date('1992-07-08'),
    note: 'Frequent customer',
    company: 'VWX Corporation',
    unitFloorRoomBuildingNo: 'Unit 404, 4/F',
    buildingNameTower: 'Sunrise Residences Tower 1',
    lotBlockPhaseHouseNo: 'Lot 8 Block 3',
    street: 'J.P. Rizal Street',
    subdivisionVillageZone: 'Green Meadows Subdivision',
    barangay: "Barangay Pinagkaisahan",
    district: '2nd District',
    city: 'Mandaluyong City',
    province: 'Metro Manila',
    zipCode: '1550',
    taxId: '1234',
    childName: null,
    childBirthDate: null,
  },
  {
    id: 10,
    createdAt: generateDate(DateFilter.MAX),
    updatedAt: new Date('2022-05-19'),
    firstName: 'Amanda',
    lastName: 'Rodriguez',
    mobile: {
      countryCode: '+63',
      number: '9109876543',
    },
    telephone: {
      countryCode: '+63',
      number: '212345678',
    },
    email: 'amanda@example.com',
    birthday: new Date('1987-01-22'),
    note: 'New customer',
    company: 'YZ Corporation',
    unitFloorRoomBuildingNo: 'Unit 506, 5/F',
    buildingNameTower: 'Sunrise Residences Tower 1',
    lotBlockPhaseHouseNo: 'Lot 8 Block 3',
    street: 'J.P. Rizal Street',
    subdivisionVillageZone: 'Green Meadows Subdivision',
    barangay: "Barangay Pinagkaisahan",
    district: '2nd District',
    city: 'Mandaluyong City',
    province: 'Metro Manila',
    zipCode: '1550',
    taxId: '1234',
    childName: null,
    childBirthDate: null,
  },
].map((item) =>
  Customer.fromJSON({
    ...item,
    ...{
      totalTransactions: 0,
      totalRefunds: 0,
      totalAmountSpent: 0,
      lastTransactionTimestamp: new Date(),
      lastTransactionId: '',
      averageAmountSpentPerTransaction: 0,
      currencyCode: CurrencyCode.PHP,
    },
  })
);
